import 'reflect-metadata';
import {app} from "./di";
import {VueModule} from "@/modules/vue";
import {SeasonModule} from "@/modules/season";
import {BaseModule} from "@/modules/base";
import {MatchModule} from "@/modules/match";
import {StaffModule} from "@/modules/staff";
import {ScoutingModule} from "@/modules/scouting";
import {FinancesModule} from "@/modules/finances";
import {YouthModule} from "@/modules/youth";
import {NotificationsModule} from "@/modules/notifications";
import {CompetitionModule} from "@/modules/competitions";
import {TeamModule} from "@/modules/team";
import {DiplomacyModule} from "@/modules/diplomacy";
import {ActionScreensModule} from "@/modules/action-screens";
import {MainMenuModule} from "@/modules/main-menu";
import {SettingsModule} from "@/modules/settings";
import {AIModule} from "@/modules/ai";
import {SponsoringModule} from "@/modules/sponsoring";
import {TrainingModule} from "@/modules/training";
import {DatabaseModule} from "@/modules/database";
import {ClubGroundsModule} from "@/modules/club-grounds";
import {StadiumModule} from "@/modules/stadium";
import {TransferMarketModule} from "@/modules/transfer-market";
import {ActionPointsModule} from "@/modules/action-points";
import {GlobalSearchModule} from "@/modules/global-search";
import {AchievementsModule} from "@/modules/archiements";

app.addModules([
  new DatabaseModule(),
  new MainMenuModule(),
  new BaseModule(),
  new VueModule(),
  new FinancesModule(),
  new SeasonModule(),
  new MatchModule(),
  new StaffModule(),
  new ScoutingModule(),
  new YouthModule(),
  new NotificationsModule(),
  new CompetitionModule(),
  new TeamModule(),
  new DiplomacyModule(),
  new ActionScreensModule(),
  new SettingsModule(),
  new AIModule(),
  new SponsoringModule(),
  new TrainingModule(),
  new ClubGroundsModule(),
  new StadiumModule(),
  new TransferMarketModule(),
  new ActionPointsModule(),
  new GlobalSearchModule(),
  new AchievementsModule(),
]);

app.run();
